import {testIdProps} from '@github-ui/test-id-props'
import {Token, type TokenProps} from '@primer/react'
import {forwardRef} from 'react'

import type {IssueType} from '../../api/common-contracts'

interface IssueTypeTokenProps extends Omit<TokenProps, 'leadingVisual' | 'text'> {
  issueType: IssueType
}

export const IssueTypeToken = forwardRef<HTMLElement, IssueTypeTokenProps>(({issueType, ...tokenProps}, ref) => (
  <Token text={issueType.name} ref={ref} {...tokenProps} {...testIdProps(`issue-type-token`)} />
))
IssueTypeToken.displayName = 'IssueTypeToken'
